import { render } from "./wSwitch.vue?vue&type=template&id=ee7c6bb4&ts=true"
import script from "./wSwitch.vue?vue&type=script&lang=ts"
export * from "./wSwitch.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__